import { render } from "./WCScanConfirmModal.vue?vue&type=template&id=49a1596f&scoped=true"
import script from "./WCScanConfirmModal.vue?vue&type=script&lang=js"
export * from "./WCScanConfirmModal.vue?vue&type=script&lang=js"

import "./WCScanConfirmModal.vue?vue&type=style&index=0&id=49a1596f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a1596f"]])

export default __exports__